<template>
  <footer class="site-footer">
    <div :class="['contentArea', { 'contentArea--mobile': isMobile }]">
      <div class="footer-top">
        <div class="footer-top__text">
          <h3 class="footer-headline">{{ $t('footerHeadline') }}</h3>
        </div>
        <div class="footer-top__actions">
          <v-btn class="btn-login" href="#caas">{{ $t('caas') }}</v-btn>
          <v-btn class="btn-get-started" href="#custom-development">{{ $t('customDevelopment') }}</v-btn>
        </div>
      </div>

      <div :class="['footer-links', isMobile ? 'footer-links--mobile' : '']">
        <!-- COLUMN 1 -->
        <div>
          <h4 class="footer-col-title">{{ $t('footerCompanyCol') }}</h4>
          <ul class="footer-list">
            <li><a class="footer-link" @click="$emit('scroll', 'hero')">{{ $t('home') }}</a></li>
            <li><a class="footer-link" @click="$emit('scroll', 'caas')">{{ $t('caas') }}</a></li>
            <li><a class="footer-link" @click="$emit('scroll', 'custom-development')">{{ $t('customDevelopment') }}</a></li>
          </ul>
        </div>

        <!-- COLUMN 2 -->
        <div>
          <h4 class="footer-col-title">{{ $t('footerServicesCol') }}</h4>
          <ul class="footer-list">
            <li><a class="footer-link" @click="$emit('scroll', 'caas')">{{ $t('ctaAsServiceTitle') }}</a></li>
            <li><a class="footer-link" @click="$emit('scroll', 'custom-development')">{{ $t('customDevelopmentTitle') }}</a></li>
            <li><a class="footer-link" @click="$emit('scroll', 'ai-chatbots')">{{ $t('aiChatbotsTitle') }}</a></li>
          </ul>
        </div>

        <!-- COLUMN 3 -->
        <div>
          <h4 class="footer-col-title">{{ $t('footerSupportCol') }}</h4>
          <ul class="footer-list">
            <li><a class="footer-link" href="mailto:info@sbs.com">{{ $t('footerContact') }}</a></li>
            <li><a class="footer-link">{{ $t('footerFaq') }}</a></li>
          </ul>
        </div>

        <!-- COLUMN 4 -->
        <div>
          <h4 class="footer-col-title">{{ $t('footerLegalCol') }}</h4>
          <ul class="footer-list">
            <li><a class="footer-link">{{ $t('footerTerms') }}</a></li>
            <li><a class="footer-link">{{ $t('footerPrivacy') }}</a></li>
          </ul>
        </div>
      </div>

      <!-- COPYRIGHT -->
      <div class="footer-bottom">
        <p class="footer-copyright">{{ $t('footerCopyright') }}</p>
        <div class="footer-socials">
          <v-icon class="social-icon">mdi-facebook</v-icon>
          <v-icon class="social-icon">mdi-instagram</v-icon>
          <v-icon class="social-icon">mdi-twitter</v-icon>
          <v-icon class="social-icon">mdi-linkedin</v-icon>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["scroll"],
};
</script>

<style scoped>
.site-footer {
  background-color: #0a0a2e;
  color: white;
  padding: 4rem 1.5rem;
  margin-top: 0;
}

.contentArea {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-left: 4rem;
  padding-right: 4rem;
  display: flex;
  flex-direction: column;
  gap: 4rem;
}

.contentArea--mobile {
  padding-left: 1rem;
  padding-right: 1rem;
  max-width: 100%;
}

.footer-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.footer-headline {
  font-weight: 800;
  font-size: 1.4rem;
}

.footer-top__actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.btn-login {
  background: transparent !important;
  border: 1px solid white !important;
  color: white !important;
}

.btn-get-started {
  background: white !important;
  color: #0a0a2e !important;
  font-weight: 700 !important;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}

.footer-links--mobile {
  grid-template-columns: repeat(2, 1fr);
}

.footer-col-title {
  margin-bottom: 0.75rem;
  font-size: 1.1rem;
  font-weight: 700;
}

.footer-list {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  opacity: 0.9;
}

.footer-link {
  color: white;
  text-decoration: none;
  cursor: pointer;
  font-size: 0.95rem;
  transition: opacity 0.2s;
}

.footer-link:hover {
  opacity: 0.7;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-copyright {
  opacity: 0.7;
  font-size: 0.9rem;
}

.footer-socials {
  display: flex;
  gap: 1.25rem;
}

.social-icon {
  color: white;
  cursor: pointer;
  transition: opacity 0.2s;
  font-size: 22px;
}

.social-icon:hover {
  opacity: 0.7;
}
</style>
